<template>
  <div v-show="addShow" v-dragDiv class="issueDetail">
    <div class="addTitle moveDragDiv">
      <span>批注详情</span>
      <i class="el-icon-close" @click="closeArea"></i>
    </div>
    <div class="nav">
      <notationDetail ref="notationDetail" type="rvt" />
    </div>
  </div>
</template>

<script>
import notationDetail from "@/views/question/notationDetail.vue";
export default {
  components: { notationDetail },
  data() {
    return {
      addShow: false,
    };
  },
  methods: {
    closeArea() {
      this.addShow = false;
    },
    init(item) {
      this.addShow = true;
      this.$nextTick(() => {
        this.$refs.notationDetail.init(item);
      });
    },
    getList() {
      this.$parent.$refs.listNotation.openList();
    },
  },
};
</script>

<style lang="scss" scoped>
.issueDetail {
  position: fixed;
  top: 35px;
  right: 330px;
  width: 360px;
  height: calc(100% - 90px);
  max-height: 870px;
  z-index: 15;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 0px 4px 1px rgba(46, 91, 255, 0.17);
  border-radius: 4px;
  .addTitle {
    cursor: move;
    width: 100%;
    height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #e8ebef;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    span {
      font-size: 16px;
      font-weight: bold;
    }
    i {
      font-size: 16px;
      cursor: pointer;
    }
  }
  .nav {
    width: 100%;
    height: calc(100% - 50px);
    // padding: 10px 15px;
    overflow: hidden;
  }
}
</style>
